var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const GET_SET_INVOICE_MODULE_CFDI = "api/invoice-module/cfdi";
export const createCFDI = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.post(GET_SET_INVOICE_MODULE_CFDI, data, config);
        }
        catch (error) {
            console.error("Error creating invoice module CFDI:", error);
            throw error;
        }
    });
};
export const searchGlobalByPaymentMethodCandidates = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.post(`${GET_SET_INVOICE_MODULE_CFDI}/global-by-payment-method/search`, data, config);
        }
        catch (error) {
            console.error("Error searching invoice module global payment method candidates:", error);
            throw error;
        }
    });
};
export const previewGlobalByPaymentMethodCFDI = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.post(`${GET_SET_INVOICE_MODULE_CFDI}/global-by-payment-method/preview`, data, config);
        }
        catch (error) {
            console.error("Error previewing invoice module global payment method CFDI:", error);
            throw error;
        }
    });
};
export const createGlobalByPaymentMethodCFDI = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.post(`${GET_SET_INVOICE_MODULE_CFDI}/global-by-payment-method`, data, config);
        }
        catch (error) {
            console.error("Error creating invoice module global payment method CFDI:", error);
            throw error;
        }
    });
};
